import { useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";

import { H3 } from "../../../AbstractElements";
import SearchBar from "../../../CommonElements/SearchBar";
import DomainCard from "../../../container/DomainCards";
import NoDataFound from "../../../container/NoDataFound";
import { useAppDispatch, useAppSelector } from "../../../ReduxToolkit/Hooks";
import { getLearningPlanByDomain } from "../../../ReduxToolkit/Reducers/LearningPlanMaster";
import { LearningPlansByDomain } from "../../../utils/Constant";

const LearningPlans = () => {
  const dispatch = useAppDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const [data, setData] = useState([]);
  const { learningPlanByDomain } = useAppSelector(
    state => state.learningPlanMaster
  );

  useEffect(() => {
    dispatch(getLearningPlanByDomain());
  }, [dispatch]);

  useEffect(() => {
    if (learningPlanByDomain?.learning_plan_domains) {
      setData(learningPlanByDomain.learning_plan_domains);
    }
  }, [learningPlanByDomain]);

  const filteredData = data?.filter(item =>
    item?.domain?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

  return (
    <div className="page-body">
      <Card>
        <CardBody>
          <div className="d-md-flex flex-row align-items-center">
            <H3 className="fw-bold">{LearningPlansByDomain}</H3>
            <div className="d-md-flex justify-content-end align-items-center mt-sm-0 mt-2 gap-3 ms-auto">
              <SearchBar
                showSearch
                className="mb-2"
                onSearch={query => setSearchQuery(query)}
              />
            </div>
          </div>
        </CardBody>
      </Card>
      <Card className="mt-3">
        <CardBody className="mt-3">
          {filteredData?.length > 0 ? (
            <Row>
              {filteredData?.map(item => (
                <Col key={item.domain_id} xs="12" sm="12" md="12" lg="12">
                  <DomainCard
                    id={item?.domain_id}
                    domainName={item?.domain}
                    learningPlans={item?.learning_plans}
                    courses={item?.courses}
                    assessments={item?.assessments}
                    users={item?.users}
                    userGroups={item?.user_groups}
                  />
                </Col>
              ))}
            </Row>
          ) : (
            <NoDataFound />
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default LearningPlans;
